module.exports = __webpack_public_path__ + "img/china.9188868c.png";